module.exports = __webpack_public_path__ + "img/img-7.27957cf8.png";